import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { BackendService } from '../../core/backend.service';
import { SnackService } from '../../shared-services/snack.service';
import { CambioSpread } from '../../configuracion/cambioSpread.model';
import { Configuracion } from '../../configuracion/configuracion.model';
import { DialogService } from '../modals/dialog.service';

@Component({
  selector: 'app-cambio-spread',
  templateUrl: './cambio-spread.component.html',
  styleUrls: ['./cambio-spread.component.scss']
})
export class CambioSpreadComponent implements OnInit  {

  @Input() cambioSpread: CambioSpread;
  @Output() onUpdateSpread = new EventEmitter<boolean>();
  staticCambioSpread = { valor: null };
  operationalCambioSpread = { valor: null };

  staticSpreads: Configuracion[];
  isLoading: boolean;

  constructor(
    private backendService: BackendService,
    private snackService: SnackService,
    private dialogService: DialogService
  ) { }

  hasCambioSpread() {
    if (this.staticCambioSpread.valor !== null) {
      return true;
    }
    return false;
  }

  async confirmCambioSpread() {
      this.dialogService.confirm('Modificar spread',
      '¿Está seguro que desea modificar el spread actual?')
      .then( res => {
        if (res) {
          this.save(res);
        }
      });
  }

  async save(res) {
    if (res) {
      this.snackService.spinner(true);
      try {
        await this.backendService.changeSpread('/configuraciones/cambio_spread?spread=' + this.operationalCambioSpread.valor);
        this.snackService.success('Spread actualizado');
        this.updateView();
        this.snackService.spinner(false);
      } catch (error) {
        this.snackService.spinner(false);
        this.snackService.error(error.message);
      }
    }
  }

  updateView() {
    this.getSpreadHistorico();
    this.staticCambioSpread.valor = this.operationalCambioSpread.valor;
  }

  ngOnInit() {
    this.backendService.getSpread('/configuraciones/spread').then(
      res => {
        this.staticCambioSpread.valor = res;
      }
    );

    this.getSpreadHistorico();

    if (this.cambioSpread) {
      this.staticCambioSpread.valor = this.cambioSpread.valor;
      this.operationalCambioSpread.valor = this.cambioSpread.valor;
    }
  }

  async getSpreadHistorico() {
    this.backendService.getSpreadHistorico('/configuraciones/spread_historico').then(
      res => {
        this.staticSpreads = res as [Configuracion];
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/cambio-spread/cambio-spread.component.ts